export default "__VITE_PUBLIC_ASSET__c15e39cb__"